window.app = window.app || {};

window.app.stickyNavigation = {
    el: {
        body: document.querySelector('body'),
        header: document.querySelector('.mt-header-group'),
        section: document.querySelector('.mt-sticky-navigation'),
        links: document.querySelectorAll('.mt-sticky-navigation__item a')
    },

    init: function () {
        const _this = this;
        if (!_this.el.section) return;

        // Navigation logic
        document.addEventListener('DOMContentLoaded', () => {
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };
            let visibleSections = [];
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const relatedSection = entry.target;
                    const sectionIndex = visibleSections.indexOf(relatedSection);
            
                    if (entry.isIntersecting) {
                        if (sectionIndex === -1) {
                            visibleSections.push(relatedSection);
                        }
                    } else {
                        if (sectionIndex !== -1) {
                            visibleSections.splice(sectionIndex, 1);
                        }
                    }
                });
            
                visibleSections.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
                _this.el.links.forEach(link => {
                    const item = link.closest('.mt-sticky-navigation__item');
                    const relatedSection = document.querySelector(link.getAttribute('href'));
            
                    if (!relatedSection) return;
                    
                    item.classList.remove('active');
                    if (visibleSections.length > 0 && visibleSections[0] === relatedSection) {
                        const offsetLeft = item.offsetLeft;
                        item.classList.add('active');
                        item.parentElement.scrollTo({ left: offsetLeft, behavior: 'smooth' });
                    }
                });
            }, observerOptions);
            

            // Navigation logic
            _this.el.links.forEach(link => {
                const item = link.closest('.mt-sticky-navigation__item');
                const href = link.getAttribute('href');
                const relatedSection = document.querySelector(href);

                if (!relatedSection || href.includes('http')) {
                    item.remove();
                    return;
                }
                if (relatedSection) {
                    observer.observe(relatedSection);
                    link.addEventListener('click', e => {
                        e.preventDefault();

                        const offsetTop = relatedSection.getBoundingClientRect().top + document.documentElement.scrollTop - _this.el.header.offsetHeight;
                        window.scrollTo({ top: offsetTop, behavior: 'smooth' });

                        // Additional DL events
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'tab_click',
                            link_text: link.innerText
                        });
                    });
                }
            });

            // URL hash logic
            if (window.location.hash) {
                const section = document.querySelector(window.location.hash);
                if (!section) return;
                const offsetTop = section.getBoundingClientRect().top + document.documentElement.scrollTop - _this.el.header.offsetHeight;
                window.scrollTo({ top: offsetTop, behavior: 'instant' });
            }
        });

        // Sticky
        let lastScrollTop = 0;
        const stickyNav = () => {
            const sectionPosition = _this.el.section.getBoundingClientRect().top + document.documentElement.scrollTop;
            const currentScrollTop = window.scrollY;

            _this.el.section.classList.toggle('sticky', currentScrollTop > sectionPosition);
            _this.el.section.classList.toggle('sticky-visible', currentScrollTop < lastScrollTop);
        
            lastScrollTop = currentScrollTop;
        };
        stickyNav();
        window.addEventListener('scroll', () => stickyNav());
    }
}
window.app.stickyNavigation.init();